import ChangeReasonModal from '../change-reason-modal/change-reason-modal';
import EnterVirtualDataFormComponent from './enter-virtual-data-form-component';
import EnterVirtualDataFormService from './enter-virtual-data-form-service';
import FormInput from '../form-input/form-input';

/***
 * The master data entry form. Contains error messages, success messages, last-updated timestamps,
 * and renders the form based on form metadata returned by the server.
 */
const enterVirtualDataForm = angular
    .module('FacilityData.EnterVirtualData.EnterVirtualDataForm', [
        ChangeReasonModal,
        FormInput
    ])
    .component('enterVirtualDataForm', EnterVirtualDataFormComponent)
    .service('EnterVirtualDataFormService', EnterVirtualDataFormService)
    .name;

export default enterVirtualDataForm;


// WEBPACK FOOTER //
// ./app/components/enter-virtual-data/enter-virtual-data-form/enter-virtual-data-form.js